import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';
import { TranslateService } from '@ngx-translate/core';
import { Path } from 'app/shared/path';
export interface Message {
   id: number;
   payload: any;
   createdDate: Date;
   readDate: Date;
}

@Injectable()
export class NotificationHelper {
   constructor(private service: NotificationService, private router: Router, private translate: TranslateService) {}

   getClass(data: any): string {
      if (data?.type === 'task' || data?.type === 'dms') {
         return data.status === 'F' ? 'noti-green' : 'noti-warn';
      }
      return 'noti-error';
   }

   getIcon(data: any): string {
      if (data?.type === 'task' || data?.type === 'dms') {
         return data.status === 'F' ? 'info' : 'warning';
      }
      return 'question_mark';
   }

   getMessage(data: any): string {
      const prefixNoti = '<div class="notify-body">';
      const suffixNoti = '</div>';
      let msgNoti: string;

      if (data?.type === 'task' || data?.type === 'dms') {
         const param = { taskName: data.taskName, requester: data.requester, action: data.action,
            commenterName: data.commenterName, ownerName: data.ownerName, rejectName: data.rejectName,
            messageEn: data.messageEn, messageTh: data.messageTh };
         if ((data.messageEn && data.messageEn.trim() !== '') || (data.messageTh && data.messageTh.trim() !== '')) {
            const lang = localStorage.getItem('lang');
            if (lang === 'en') {
               msgNoti = prefixNoti + data.messageEn + suffixNoti;
            } else if (lang === 'th') {
               msgNoti = prefixNoti + data.messageTh + suffixNoti;
            } else {
               msgNoti = prefixNoti + data.messageEn + suffixNoti;
            }
         } else {
            let action = data?.action;
            if (data && typeof data?.action === 'string') {
               action = data?.action.split(' ').join('_');
            }
            this.translate.get('notification.task.' + action, param).subscribe(msg => {
               msgNoti = prefixNoti + msg + suffixNoti;
            });
         }
      } else {
         msgNoti = 'Unknown message: ' + JSON.stringify(data);
      }
      return msgNoti;
   }

   getAction(data: any): string | undefined {
      if (data?.type === 'task') {
         return 'View';
      }
      return undefined;
   }

   doAction(message: Message): void {
      if (!message.readDate) {
         this.service.read(message.id).subscribe(() => message.readDate = new Date());
      }
      if (message.payload?.type === 'task') {
         this.openTaskNoti(message.payload);
      }
      if (message.payload?.type === 'dms') {
         this.openFileNoti(message.payload);
      }
   }

   isOpenLink(data: any): boolean {
      if (data.type === 'task') {
         if (data.action !== 'deleted') {
            return true;
         }
      } else if (data.type === 'dms') {
         if (data.action !== 'deleted' && data.action !== 'rename' && data.action !== 'move') {
            return true;
         }
      }
      return false;
   }

   getCursor(data: any): string {
      let value = this.isOpenLink(data);
      if (value) {
         return 'pointer';
      } else {
         return 'default';
      }
   }

   private openTaskNoti(data: any): void {
      if (this.isOpenLink(data)) {
         this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
            this.router.navigate(['/signdoc/', data.id]);
         });
      }
   }

   private openFileNoti(data: any): void {
      if (this.isOpenLink(data)) {
         localStorage.setItem('url', Path.combine(data.folderPath))
         if (!data.isFolder) {
            this.router.navigateByUrl('/file/' + data.id);
         } else {
            this.router.navigateByUrl(data.folderPath);
         }
      }
   }
}
